import { useCallback, useState } from 'react';
import { SOURCE_COMPONENT, SOURCE_CONTEXT, TwcXflowModal } from '@atlassian/twc-xflow-modal';

import { createRender } from './types';

export const render = createRender(({ cloudId, locale }) => {
	const [isModalOpen, setIsModalOpen] = useState(true);

	const handleClose = useCallback(() => {
		if (globalThis.location && globalThis.history) {
			try {
				const url = new URL(globalThis.location.href);
				if (url.searchParams.has('openTwcXflowModal')) {
					url.searchParams.delete('openTwcXflowModal');
					globalThis.history.replaceState({}, '', url.toString());
				}
			} catch {}
		}

		setIsModalOpen(false);
	}, []);

	if (!cloudId || !isModalOpen) {
		return null;
	}

	return (
		<TwcXflowModal
			cloudId={cloudId}
			locale={locale}
			onClose={handleClose}
			testId="screen-space-flags-twc-xflow-modal-v2"
			sourceComponent={SOURCE_COMPONENT.TOWNSQUARE_TWC_XFLOW_MODAL_V2}
			sourceContext={SOURCE_CONTEXT.SCREEN_SPACE_FLAGS}
		/>
	);
});

export default render;
